// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"946ee117","261":"14c96b1e","787":"28cb0dcd","861":"9f3ccc2f"}[chunkId] + ".chunk.js";
};